import { Routes } from '@angular/router';

import { CoreComponent } from './core/core.component';
import { LoginComponent } from './login/login.component';
import { Page404Component } from './page404/page404.component';
import { RedirectComponent } from "./core/redirect/redirect.component";
import { authGuard } from "./_shared/helpers";

import { DASHBOARD_ROUTES } from './pages/dashboard/dashboard.routes';
import { PROJECT_ROUTES } from './pages/projects/project-routes';
import { JOB_ROUTES } from "./pages/jobs/job-routes";
import { CONTACT_ROUTES } from './pages/contacts/contact-routes';
import { PERSON_ROUTES } from './pages/persons/person-routes';
import { COMPONENT_ROUTES } from "./pages/component/component-routes";
import { REQUEST_ROUTES } from './pages/requests/request-routes';
import { ORDER_ROUTES } from "./pages/orders/order-routes";
import { OFFER_ROUTES } from "./pages/offers/offer-routes";
import { INVOICE_ROUTES } from './pages/invoices/invoice-routes';
import { DELIVERY_ROUTES } from "./pages/delivery/delivery-routes";
import { NOTIFICATION_ROUTES } from "./pages/notifications/notification-routes";
import { CONFIRMATION_ROUTES } from "./pages/confirmations/confirmation-routes";
import { WAREHOUSE_ROUTES } from "./pages/warehouse/warehouse-routes";

export const routes: Routes = [
  { path: '',
    canActivate: [authGuard],
    component: RedirectComponent,
    pathMatch: 'full',
  },
  {
    path: 'login',
    component: LoginComponent
  },
  {
    path: '',
    component: CoreComponent,
    canActivate: [authGuard],
    children: [
      ...DASHBOARD_ROUTES,
      ...PROJECT_ROUTES,
      ...JOB_ROUTES,
      ...CONTACT_ROUTES,
      ...PERSON_ROUTES,
      ...COMPONENT_ROUTES,
      ...REQUEST_ROUTES,
      ...ORDER_ROUTES,
      ...OFFER_ROUTES,
      ...INVOICE_ROUTES,
      ...DELIVERY_ROUTES,
      ...NOTIFICATION_ROUTES,
      ...CONFIRMATION_ROUTES,
      ...WAREHOUSE_ROUTES,
      {
        path: '**',
        component: Page404Component,
        canActivate: [authGuard]
      }
    ]
  }
];
